import React from 'react';
import { FontIcon } from 'material-ui';
import { fromJS } from 'immutable';
import { css, StyleSheet } from 'aphrodite';
import DragSource from '../../../tc-ui/dnd/drag-source';
import DropTarget from '../../../tc-ui/dnd/drop-target';
import DnDContainer from '../../../tc-ui/dnd/container';
import SingleExtra from './single-extra';
import SingleSelect from 'react-select';
import R from 'ramda';

const border = '1px dashed rgba(0, 0, 0, 0.54)';
const styles = StyleSheet.create({
  extrasContainer: { display: 'flex', width: '100%' },
  draggableCard: { margin: '0px 0px 8px 8px' },
  extraContainer: {
    border,
    display: 'flex',
    alignItems: 'flex-start',
    margin: '8px auto',
    padding: '6px',
  },
  emptyDropTarget: { padding: '12px 6px', width: '70%', height: '83px', color: 'rgba(0, 0, 0, 0.34)', margin: '0px 0px 8px 8px', backgroundColor: '#f5f5f5' },
  activeDropTarget: { border: '2px dashed #14872b', width: '70%', padding: '12px 6px', height: '83px', margin: '0px 0px 8px 8px', backgroundColor: '#f2f7f3' },
  canDropClassName: { border: '2px dashed #94b3d4', width: '70%', padding: '12px 6px', height: '83px', margin: '0px 0px 8px 8px', backgroundColor: '#ebf2f9' },
  nonSortableItem: { display: 'block' },
});

const ExportExtrasPreview = ({
  updateThisProductWithKeyPath,
  extraLines,
  pickedExtras,
  notPickedExtras,
  allExtras = [],
  convertedContract,
  updateWithKeyPath,
  editCarriesTo,
}) => {
  const availableExtraLines = R.values(extraLines);
  const updateAcrossProducts = (picked, all) => {
    updateWithKeyPath(['convertedContract'], fromJS(convertedContract.map(product => {
      return ({
        ...product,
        pickedExtras: picked,
        allExtras: all,
      });
    })));
  };
  const updateSingleProduct = (picked, all) => {
    updateThisProductWithKeyPath(['pickedExtras'], fromJS(picked));
    updateThisProductWithKeyPath(['allExtras'], fromJS(all));
  };
  const updateFn = R.call(R.cond([
    [R.equals('sameSeasonAcrossProducts'), R.always(updateAcrossProducts)],
    [R.equals('sameFieldAllSeasonsAllProducts'), R.always(updateAcrossProducts)],
    [R.T, R.always(updateSingleProduct)],
  ]), editCarriesTo);
  return (
    <div>
      <div className={css(styles.extrasContainer)}>
        <div style={{ width: '20%' }}/>
        <div style={{ textAlign: 'center', fontWeight: 'bold', paddingBottom: '16px', fontSize: '18px', width: '80%', borderBottom: '1px solid rgba(0, 0, 0, 0.34)' }}>Extras</div>
      </div>
      <div style={{ width: '80%', marginLeft: '20%' }}>
        {
          (() => {
            if (R.all(R.isEmpty, availableExtraLines)) {
              return (<div style={{ color: 'rgb(255, 152, 0)', marginLeft: '8px', lineHeight: '56px' }}>No extras configured in Tourplan</div>);
            }
            if (R.isEmpty(allExtras)) {
              return (<div style={{ color: 'rgb(255, 152, 0)', marginLeft: '8px', lineHeight: '56px' }}>
                No available extras
              </div>);
            }
            return allExtras.map((extra, index) => {
              return (
                <div
                  key={`${index}${extra.extraType}${extra.extraCode}${extra.adult}${extra.child}${extra.infant}`}
                  className={css(styles.extraContainer)}
                >
                  <SingleExtra
                    extra={extra}
                    updateWithKey={(key, value) => {
                      const all = allExtras.map((obj, thisIndex) => {
                        if (thisIndex === index) return { ...obj, [key]: value };
                        return obj;
                      });
                      updateFn(pickedExtras, all);
                    }}
                  />
                  <div style={{ width: '50%' }}>
                    <SingleSelect
                      name="tourplantarget"
                      options={R.keys(extraLines).map((k, i) => ({
                        value: k,
                        label: extraLines[k],
                        // disable if other extra has taken the place
                        disabled: Boolean(pickedExtras[i] && !R.isEmpty(pickedExtras[i])),
                      }))
                        .filter(o => o.label)}
                      onChange={(selected) => {
                        if (!selected) {
                          // remove
                          const theIndex = parseInt(extra.extraLineKey.replace('extra', '')) - 1;
                          const picked = R.update(theIndex, {}, pickedExtras);
                          const all = R.update(index, { ...extra, extraLineKey: null }, allExtras);
                          updateFn(picked, all);
                        } else {
                          const newIndex = parseInt(selected.value.replace('extra', '')) - 1;
                          const picked = R.update(newIndex, extra, pickedExtras);
                          const all = R.update(index, { ...extra, extraLineKey: selected.value }, allExtras);
                          updateFn(picked, all);
                        }
                      }}
                      value={extra.extraLineKey}
                      placeholder="Please select Tourplan target"
                      clearable
                      scrollMenuIntoView={false}
                    />
                  </div>
                </div>
              );
            });
          })()
        }
      </div>
    </div>);
};

export default ExportExtrasPreview;



// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-content-preview/preview-extras.jsx